import { ReactElement } from 'react';

//  material-ui
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { useAppSelector } from '../../hooks/useAppStore';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../models/store';

// styles
const LoaderWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1301,
  width: '100%'
});

const ajaxLoaderVisibleSelector = createSelector(
  (state: RootState) => state.app.ajaxLoader,
  (ajaxLoader) => ajaxLoader > 0
);

const Loader = (): ReactElement => {
  const isAjaxLoaderVisible = useAppSelector(ajaxLoaderVisibleSelector);

  return isAjaxLoaderVisible ? (
    <LoaderWrapper>
      <LinearProgress color='primary' />
    </LoaderWrapper>
  ) : (
    <></>
  );
};

export default Loader;
